import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useDropdown from '../../../../lib/hooks/useDropdown';
import {
  CampaignWrapper,
  TileImage,
  CampaignText,
  OlderCampaignsMenu,
  OlderCampaign,
  MenuIcon,
  MenuText,
} from './StyledComponents';

export const MoreCampaignsMenu = ({
  campaigns,
  selectedCampaignUuid,
  setSelectedCampaign,
  year,
}) => {
  const { t } = useTranslation('activityBoard');
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();

  const isSelected = campaigns.find(
    campaign => campaign.uuid === selectedCampaignUuid,
  );

  return (
    <CampaignWrapper
      ref={buttonRef}
      onClick={() => setShowDropdown(state => !state)}
      data-testid="campaign-wrapper"
    >
      <MenuIcon isSelected={isSelected}>{campaigns.length}</MenuIcon>
      <CampaignText isSelected={isSelected} variant="subtitle2">
        {year || t('moreCampaignsMenu.more')}
      </CampaignText>
      {showDropdown && (
        <OlderCampaignsMenu ref={dropdownRef}>
          {campaigns.map(campaign => (
            <OlderCampaign
              onClick={() => setSelectedCampaign(campaign)}
              key={campaign.uuid}
            >
              <TileImage
                height="37px"
                width="100%"
                maxWidth="37px"
                src={campaign.tileImage}
              />
              <MenuText variant="small3">{campaign.name}</MenuText>
            </OlderCampaign>
          ))}
        </OlderCampaignsMenu>
      )}
    </CampaignWrapper>
  );
};

MoreCampaignsMenu.propTypes = {
  campaigns: PropTypes.array,
  selectedCampaignUuid: PropTypes.string,
  setSelectedCampaign: PropTypes.func,
  year: PropTypes.string,
};
